export const EXTERNAL_TYPES = [
  'recommendations',
  'articles',
  'interviews',
  'videos',
];

export const SINGLE_TYPES = ['recommendations', 'default'];

export const NO_PROGRAMS_MESSAGE =
  'Увы, ничего подходящего не нашлось. Но мы уже работаем над этим, скоро рекомендации станут лучше!';



// WEBPACK FOOTER //
// ./src/pages/profile/views/cabinet/components/block/const.ts